import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	contactTypes: [],
	isLoading: false,
	error: false,
};

const contactTypesSlice = createSlice({
	name: 'contactTypes',
	initialState,
	reducers: {
		storeContactTypes: (state, action) => {
			state.contactTypes = action.payload;
		},
	},
});

export const selectAllContactTypes = (state) => {
	return state.contactTypes;
};

export const { storeContactTypes } = contactTypesSlice.actions;

export default contactTypesSlice.reducer;
